import * as React from 'react';
import { cn } from '@/lib/utils';

const control =
  'w-full min-w-0 rounded-md border border-[var(--border-strong)] bg-[var(--card)] px-2.5 text-sm text-[var(--foreground)] ' +
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ring)]';

export function Field({
  label,
  error,
  hint,
  required,
  children,
}: {
  label: string;
  error?: string;
  hint?: string;
  required?: boolean;
  children: React.ReactNode;
}) {
  return (
    <div className="space-y-1">
      <label className="block text-xs font-medium text-[var(--muted-foreground)]">
        {label}
        {required && <span className="ms-0.5 text-red-600">*</span>}
      </label>
      {children}
      {error ? (
        <p className="text-xs text-red-600">{error}</p>
      ) : hint ? (
        <p className="text-xs text-[var(--muted-foreground)]">{hint}</p>
      ) : null}
    </div>
  );
}

export const Select = React.forwardRef<
  HTMLSelectElement,
  React.SelectHTMLAttributes<HTMLSelectElement>
>(({ className, ...props }, ref) => (
  <select ref={ref} className={cn('h-9', control, className)} {...props} />
));
Select.displayName = 'Select';

export const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.TextareaHTMLAttributes<HTMLTextAreaElement>
>(({ className, ...props }, ref) => (
  <textarea ref={ref} className={cn('py-1.5', control, className)} {...props} />
));
Textarea.displayName = 'Textarea';
